module.exports = __webpack_public_path__ + "img/sqzs.0745d23d.png";